import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/Services/api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserData } from 'src/app/Services/data.model';

@Injectable({
  providedIn: 'root'
})
export class FeeApiService {

  browserDomain : string = this.service.browserDomain;
  constructor(private http: HttpClient, private service: ApiService) { }

  studentIdSubject = new BehaviorSubject(null);
  URLAddress(address){
    const FinalURL = this.service.URLAddress(address,'fee')
    return FinalURL; 
  }
  
  ///////Other Module API......


  // private printData$: BehaviorSubject<any> = new BehaviorSubject(null);
  // getPrintData(): Observable<any> { 
  //     return this.printData$.asObservable();
  // }

  // setPrintData(data: any) {
  //     this.printData$.next(data);
  //     console.log(this.printData$ , data)
  // }


  getCourseList(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/course?entity=' +entityId+'&session='+session))
  }
  getCourseData(entityId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/course?id='+entityId) );
  }
  viewFeeMasterData(entityId, session): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/feeMaster?entity=' +entityId+'&session='+session))
  }
  listCourseWiseReport( courseWiseReportData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/courseWiseCollection/feeReports'), courseWiseReportData)
  }
  listCategoryWiseReport( courseWiseReportData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/categoryWiseCollection/feeReports'), courseWiseReportData)
  }
  listFeeHeadWiseReport( courseWiseReportData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/feeHeadWiseCollection/feeReports'), courseWiseReportData)
  }
  sendDueFeeSMSCommunication( formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendDueFeeSMS/communication'), formData)
  } 
  sendWhatsappSms(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendDueFeeWhatsAppWeb/communication'), formData)
  }
  sendWhatsapp(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendDueFeeWhatsApp/communication'), formData)
  }
  sendMultipleAdmissionReminderSMSCommunication( formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendMultipleAdmissionReminderSMS/communication'), formData)
  } 
  sendMultipleAdmissionReminderWhstasAppSMSCommunication(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendMultipleAdmissionReminderWhatsAppWeb/communication'), formData)
  }
  sendDueFeeMSTeams( formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendDueFeeMSTeams/communication'), formData)
  }

  listCommunicationTemplate(entityId, eventType, channel):Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/communicationTemplate?entity='+entityId+'&eventType='+eventType+ '&channel='+channel))
  }
  viewCommunicationConfig(entityId, session):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/communicationConfig?entity='+entityId+'&session='+session))
  }  

  createAdjustment(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/createAdjustment/transaction'), formData)
  }
  getTransactionList(formData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/getTransactions/odPay'),formData) 
  }
  geBulkRefundDeatils(formData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/getBulkFeeRefundDetails/refundTransaction'),formData) 
  }

  createBulkFeeRefund(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/createBulkFeeRefund/refundTransaction'),formData) 
  }

  retryEntityApi(row):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/retryEntityAPI/odPay'),row) 
  }
  updateStatus(row):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/updateStatus/odPay'),row) 
  }

  updateStudentDemandAmount(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/updateStudentDemandAmount/student'), formData);
  }

  updateStudentDemandAmountByExcel(formData: FormData, params: any): Observable<any> {
    const queryString = Object.keys(params).map(key => key + '=' + encodeURIComponent(params[key])).join('&');
    return this.http.post<any>(this.URLAddress('/updateStudentDemandAmountXL/student?' + queryString), formData);
  }
}
